export default __webpack_public_path__ + "static/media/references__firmix.020659ca.jpg";